const LocalStorageHelper = {
	get(key) {
		if (!key) {
			throw new Error("You need to specify a key");
		}

		try {
			return JSON.parse(localStorage.getItem(key));
		} catch {
			/* istanbul ignore next */
			return {};
		}
	},
	set(key, json) {
		if (!key) {
			throw new Error("You need to specify a key");
		}

		try {
			localStorage.setItem(key, JSON.stringify(json));
		} catch {
			/* ignored */
		}
	},
	delete(key) {
		if (!key) {
			throw new Error("You need to specify a key");
		}

		try {
			localStorage.removeItem(key);
		} catch {
			/* ignored */
		}
	},
	update(storageKey, updateKey, newValue) {
		try {
			let object = {};
			const storeValue = localStorage.getItem(storageKey);
			if (storeValue !== null) {
				object = JSON.parse(localStorage.getItem(storageKey));

				if (object.hasOwnProperty(updateKey)) {
					object[updateKey] = newValue;
				} else {
					object[updateKey] = newValue;
				}
			} else {
				object[updateKey] = newValue;
			}

			this.set(storageKey, object);
		} catch {
			/* ignored */
		}
	},
};

export default LocalStorageHelper;
